import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';

export const SpeedDialModal = ({ children, containerClass }) => {
    const [open, setOpen] = useState(false);
    const [modalAnchor, setModalAnchor] = useState(null);

    const handleClick = (event) => {
        setOpen(true);
        setModalAnchor(event.currentTarget);
    };

    const handleClose = () => {
        setOpen(false);
        setModalAnchor(null);
    };

    const openModal = Boolean(modalAnchor);

    return (
        <div>
            <SpeedDial
                ariaLabel="SpeedDial"
                sx={{ position: 'fixed', bottom: 64, right: 16, zIndex: 3 }}
                icon={<SpeedDialIcon />}
                onClick={handleClick}
                open={open}
            />
            <Popover
                open={openModal}
                sx={{ zIndex: 3 }}
                anchorEl={modalAnchor}
                onClose={handleClose}
                className='popover-content'
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                style={{ marginTop: -115 }}
            >
                <div className={containerClass} onClick={handleClose} aria-hidden='true'>
                    {children}
                </div>
            </Popover>
        </div>
    )
}